import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ObjectionHandler } from './components/ObjectionHandler';
import { TestimonialSection } from './components/TestimonialSection';
import { CTASection } from './components/CTASection';
import { BookCallSection } from './components/BookCallSection';
import { Footer } from './components/Footer';
export function App() {
  return <>
      <MetaPixel data-id="element-0" />
      <div className="flex flex-col min-h-screen bg-orange-50" data-id="element-1">
        <Header data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <HeroSection data-id="element-4" />
          <ObjectionHandler data-id="element-5" />
          <TestimonialSection data-id="element-6" />
          <BookCallSection data-id="element-7" />
          <CTASection data-id="element-8" />
        </main>
        <Footer data-id="element-9" />
      </div>
    </>;
}